import { ActivatedRoute } from '@angular/router';
import { OrderViewModel } from 'libs/core/src/lib/model/view-model/order/order.view.model';

export class CreatePaymentRedirectUrl {
  public paymentChannel: string;
  public order: OrderViewModel;
  public route: ActivatedRoute;
}
